module.exports = __webpack_public_path__ + "static/marvelEnterprise@2x-c1b017aa8e9b58ae0eedbd3b9d1adeab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/user-testing/marvelEnterprise@2x.jpg
// module id = 2715
// module chunks = 248023476013587